import { API_BASE_URL_AWARI } from '@/constants/api'
import { CreditsModel } from '@/models'
import setAuthorization from '@/utils/helpers/setAuthorization'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const creditsRepository = createApi({
	reducerPath: 'creditsRepository',
	baseQuery: fetchBaseQuery({
		prepareHeaders: setAuthorization,
		baseUrl: API_BASE_URL_AWARI,
	}),
	tagTypes: ['Credits'],

	endpoints: (builder) => ({
		list: builder.query<CreditsModel.List, void>({
			query: () => ({
				url: `/credits`,
				method: 'GET',
			}),
			providesTags: ['Credits'],
		}),
	}),
})

export default creditsRepository
